import { useAccountingIntegrationStatusQuery } from 'modules/accounting-integration/apis';

export function useAccountLength(): number | undefined {
  const result = useAccountingIntegrationStatusQuery();
  if (result.status !== 'success') {
    return undefined;
  }
  if (
    result.data.integration === 'switchInProgress' ||
    result.data.integration === 'noIntegration'
  ) {
    return undefined;
  }
  const accountLengthFieldValue =
    result.data.descriptor.settingsAccountingHeaderFields?.find(
      ({ fieldName }) => fieldName === 'accountLength',
    )?.fieldValue;
  return ((accountLengthFieldValue ?? {}) as { accountsPayableLength: number })
    .accountsPayableLength;
}
